// ============================================================
// Mock data — El Faro
// Radar de subvenciones y convocatorias de fundaciones.
//
// Fuentes: webs institucionales (scraping diario) + buzones de
// newsletters. Cada oportunidad pertenece a una organización
// (IH Barcelona, IH Madrid…) o es transversal a todas.
// ============================================================

export const FARO_ORGS = [
  { id: 'all',       name: 'Transversal',   short: 'Transversal', hue: 258 },
  { id: 'ih-bcn',    name: 'IH Barcelona',  short: 'Barcelona',   hue: 200 },
  { id: 'ih-mad',    name: 'IH Madrid',     short: 'Madrid',      hue: 30 },
];

export const FARO_SOURCES = [
  {
    id: 'src-caixa', kind: 'web', name: 'Fundación "la Caixa" · Convocatorias',
    url: 'https://fundacionlacaixa.org/es/convocatorias',
    org: 'all', freq: 'daily', status: 'active',
    lastRun: '2026-09-01T09:00:00', found: 62, foundLast: 3,
  },
  {
    id: 'src-accio', kind: 'web', name: 'ACCIÓ · Ajuts i subvencions',
    url: 'https://www.accio.gencat.cat/ca/serveis/ajuts-financament/',
    org: 'ih-bcn', freq: 'daily', status: 'active',
    lastRun: '2026-09-01T09:00:00', found: 41, foundLast: 2,
  },
  {
    id: 'src-ftef', kind: 'web', name: 'Fundación Telefónica · Programas',
    url: 'https://www.fundaciontelefonica.com/convocatorias/',
    org: 'all', freq: 'weekly', status: 'active',
    lastRun: '2026-08-31T09:00:00', found: 18, foundLast: 1,
  },
  {
    id: 'src-cmadrid', kind: 'web', name: 'Comunidad de Madrid · Ayudas y becas',
    url: 'https://www.comunidad.madrid/servicios/ayudas-becas',
    org: 'ih-mad', freq: 'daily', status: 'warning',
    lastRun: '2026-09-01T09:00:00', found: 27, foundLast: 0,
    note: 'La web ha cambiado de estructura: revisión manual recomendada.',
  },
  {
    id: 'src-eu', kind: 'web', name: 'Funding & Tenders Portal (UE)',
    url: 'https://ec.europa.eu/info/funding-tenders/',
    org: 'all', freq: 'weekly', status: 'paused',
    lastRun: '2026-08-24T09:00:00', found: 9, foundLast: 0,
  },
  // --- buzones de newsletters ---
  {
    id: 'src-mail-all', kind: 'mail', name: 'Buzón general de newsletters',
    url: 'faro@impacthub.net', org: 'all', freq: 'daily', status: 'active',
    lastRun: '2026-09-01T09:00:00', found: 148, foundLast: 4,
    senders: ['newsletter@fundacionlacaixa.org', 'info@fundacionbancosabadell.com', 'boletin@ashoka.org', 'news@euclidnetwork.eu'],
    lastMail: 'Convocatoria Art for Change 2027 — Fundación "la Caixa"',
  },
  {
    id: 'src-mail-bcn', kind: 'mail', name: 'Buzón IH Barcelona',
    url: 'faro.bcn@impacthub.net', org: 'ih-bcn', freq: 'daily', status: 'active',
    lastRun: '2026-09-01T09:00:00', found: 54, foundLast: 2,
    senders: ['comunicacio@accio.gencat.cat', 'butlleti@barcelonactiva.cat'],
    lastMail: 'Ajuts a projectes d\'economia social 2026 — Barcelona Activa',
  },
  {
    id: 'src-mail-mad', kind: 'mail', name: 'Buzón IH Madrid',
    url: 'faro.mad@impacthub.net', org: 'ih-mad', freq: 'daily', status: 'active',
    lastRun: '2026-09-01T09:00:00', found: 33, foundLast: 1,
    senders: ['boletin@madrid.org', 'news@fundacionmapfre.org'],
    lastMail: 'Ayudas a la acción social 2026 — Fundación Mapfre',
  },
];

const S = (id) => FARO_SOURCES.find((s) => s.id === id);
const srcName = (id) => (S(id) || {}).name || '—';

function opp(o) {
  return {
    destination: 'proyecto',
    status: 'new',
    currency: 'EUR',
    ...o,
    sourceName: srcName(o.sourceId),
    sourceKind: (S(o.sourceId) || {}).kind || 'web',
  };
}

export const FARO_OPPORTUNITIES = [
  opp({
    id: 'faro-001', kind: 'convocatoria',
    title: 'Convocatoria Art for Change 2027 — cultura y transformación social',
    funder: 'Fundación "la Caixa"', funderShort: 'la Caixa',
    org: 'all', destination: 'proyecto',
    amount: 60_000, coFunding: '80% del coste total, máx. 60.000 €',
    published: '2026-08-28', deadline: '2026-10-15',
    scope: 'España y Portugal',
    sourceId: 'src-mail-all', detectedAt: '2026-09-01T09:02:00',
    score: 88,
    tags: ['Cultura', 'Impacto social', 'Comunidad'],
    summary: 'Apoyo a proyectos artísticos que generen transformación social en colectivos vulnerables, con participación activa de la comunidad.',
    requirements: [
      'Entidad sin ánimo de lucro o entidad con actividad de interés social',
      'Proyecto con al menos 12 meses de ejecución',
      'Memoria técnica y presupuesto detallado',
      'Colaboración con al menos una entidad social del territorio',
    ],
    matched: ['Temática: impacto social', 'Ámbito: España', 'Importe ≥ 25.000 €', 'Plazo > 30 días'],
    unmatched: ['No cubre gastos de estructura'],
    excerpt: '«Podrán presentarse entidades sin ánimo de lucro con sede en España o Portugal que desarrollen proyectos artísticos de carácter social. La dotación máxima por proyecto será de 60.000 euros, con una cofinanciación máxima del 80% del coste total.»',
    url: 'https://fundacionlacaixa.org/es/convocatorias/art-for-change-2027',
  }),
  opp({
    id: 'faro-002', kind: 'subvencion',
    title: 'Ajuts Cupons a la Innovació — ACCIÓ 2026',
    funder: 'ACCIÓ — Generalitat de Catalunya', funderShort: 'ACCIÓ',
    org: 'ih-bcn', destination: 'proyecto',
    amount: 20_000, coFunding: '100% hasta 20.000 € en asesoramiento',
    published: '2026-08-30', deadline: '2026-09-30',
    scope: 'Cataluña',
    sourceId: 'src-accio', detectedAt: '2026-09-01T09:01:00',
    score: 74,
    tags: ['Innovación', 'Pymes', 'Consultoría'],
    summary: 'Cupones para contratar servicios de innovación y transformación digital en pymes catalanas. Impact Hub puede actuar como proveedor acreditado.',
    requirements: [
      'Pyme con establecimiento operativo en Cataluña',
      'Proveedor acreditado por ACCIÓ',
      'Ejecución antes del 31/12/2027',
    ],
    matched: ['Ámbito: Cataluña', 'Temática: innovación', 'Fuente prioritaria'],
    unmatched: ['Importe < 25.000 €'],
    excerpt: '«L\'ajut consisteix en un cupó de fins a 20.000 euros per a la contractació de serveis d\'innovació prestats per proveïdors acreditats per ACCIÓ.»',
    url: 'https://www.accio.gencat.cat/ca/serveis/ajuts-financament/cupons-innovacio',
  }),
  opp({
    id: 'faro-003', kind: 'convocatoria',
    title: 'Premios y ayudas a la acción social 2026',
    funder: 'Fundación Mapfre', funderShort: 'Mapfre',
    org: 'ih-mad', destination: 'proyecto',
    amount: 30_000, coFunding: 'Ayuda directa, no requiere cofinanciación',
    published: '2026-08-27', deadline: '2026-09-19',
    scope: 'España',
    sourceId: 'src-mail-mad', detectedAt: '2026-09-01T09:03:00',
    score: 66,
    tags: ['Acción social', 'Empleo'],
    summary: 'Ayudas a proyectos de inserción laboral de personas en riesgo de exclusión.',
    requirements: ['Entidad con más de 2 años de actividad', 'Proyecto de ámbito nacional o autonómico', 'Auditoría de cuentas del último ejercicio'],
    matched: ['Temática: empleo e inclusión', 'Ámbito: España'],
    unmatched: ['Plazo ajustado (< 30 días)'],
    excerpt: '«Se valorará especialmente el número de personas beneficiarias insertadas laboralmente durante los 12 meses posteriores al programa.»',
    url: 'https://www.fundacionmapfre.org/ayudas-accion-social-2026',
  }),
  opp({
    id: 'faro-004', kind: 'convocatoria',
    title: 'Programa de eventos de divulgación tecnológica en territorios',
    funder: 'Fundación Telefónica', funderShort: 'F. Telefónica',
    org: 'all', destination: 'evento',
    amount: 25_000, coFunding: 'Hasta 25.000 € por evento',
    published: '2026-08-26', deadline: '2026-10-02',
    scope: 'España',
    sourceId: 'src-ftef', detectedAt: '2026-08-31T09:04:00',
    score: 81,
    tags: ['Eventos', 'Digitalización', 'Talento'],
    summary: 'Financiación de encuentros, hackatones y jornadas de divulgación sobre competencias digitales fuera de grandes capitales.',
    requirements: ['Evento presencial de al menos 1 jornada', 'Mínimo 150 asistentes', 'Plan de comunicación y métricas de impacto'],
    matched: ['Destino: eventos', 'Temática: digitalización', 'Ámbito: España', 'Plazo > 30 días'],
    unmatched: [],
    excerpt: '«Se priorizarán propuestas ubicadas en municipios de menos de 100.000 habitantes y con participación de agentes locales del ecosistema emprendedor.»',
    url: 'https://www.fundaciontelefonica.com/convocatorias/eventos-territorio-2026',
  }),
  opp({
    id: 'faro-005', kind: 'subvencion',
    title: 'Apoios à economia social — Portugal 2030',
    funder: 'IAPMEI · Portugal 2030', funderShort: 'IAPMEI',
    org: 'all', destination: 'proyecto',
    amount: 150_000, coFunding: '75% de los costes elegibles',
    published: '2026-08-25', deadline: '2026-11-14',
    scope: 'Portugal',
    sourceId: 'src-eu', detectedAt: '2026-09-01T09:05:00',
    score: 79,
    tags: ['Economía social', 'Emprendimiento'],
    summary: 'Apoyo a la creación y consolidación de entidades de economía social en Portugal continental.',
    requirements: ['Entidad registrada en Portugal', 'Plan de sostenibilidad a 3 años', 'Certificación de situación tributaria regularizada'],
    matched: ['Ámbito: Portugal', 'Temática: economía social', 'Importe ≥ 25.000 €'],
    unmatched: ['Requiere entidad con NIF portugués'],
    excerpt: '«A taxa de cofinanciamento é de 75% das despesas elegíveis, até ao limite de 150.000 euros por candidatura.»',
    url: 'https://www.iapmei.pt/apoios-economia-social-2026',
  }),
  opp({
    id: 'faro-006', kind: 'convocatoria',
    title: 'Ashoka Changemakers — cohorte de emprendimiento social 2027',
    funder: 'Ashoka España', funderShort: 'Ashoka',
    org: 'all', destination: 'proyecto',
    amount: 45_000, coFunding: 'Beca + acompañamiento durante 18 meses',
    published: '2026-08-24', deadline: '2026-10-30',
    scope: 'España',
    sourceId: 'src-mail-all', detectedAt: '2026-08-31T09:06:00',
    score: 72, status: 'review',
    tags: ['Emprendimiento', 'Aceleración'],
    summary: 'Selección de organizaciones que lideran soluciones sistémicas; incluye beca económica y programa de acompañamiento.',
    requirements: ['Solución con al menos 2 años de recorrido', 'Evidencias de impacto medible', 'Entrevista con el comité de selección'],
    matched: ['Temática: emprendimiento social', 'Plazo > 30 días'],
    unmatched: ['Proceso de selección largo (4 meses)'],
    excerpt: '«El programa incluye una beca de 45.000 euros distribuida en 18 meses y acceso a la red global de Fellows.»',
    url: 'https://www.ashoka.org/es/convocatoria-2027',
  }),
  opp({
    id: 'faro-007', kind: 'subvencion',
    title: 'Subvenciones para actividades de fomento del emprendimiento local',
    funder: 'Ayuntamiento de Madrid', funderShort: 'Ayto. Madrid',
    org: 'ih-mad', destination: 'evento',
    amount: 40_000, coFunding: '70% del gasto subvencionable',
    published: '2026-08-22', deadline: '2026-09-12',
    scope: 'Madrid',
    sourceId: 'src-cmadrid', detectedAt: '2026-08-31T09:07:00',
    score: 63, status: 'review',
    tags: ['Eventos', 'Emprendimiento', 'Local'],
    summary: 'Ayudas a jornadas, ferias y programas de sensibilización empresarial en la ciudad de Madrid.',
    requirements: ['Actividad ejecutada en el municipio de Madrid', 'Justificación económica en 3 meses', 'Sin ánimo de lucro'],
    matched: ['Destino: eventos', 'Ámbito: Madrid'],
    unmatched: ['Plazo ajustado (< 30 días)', 'Justificación exigente'],
    excerpt: '«Serán subvencionables los gastos de organización, difusión y personal directamente vinculados a la actividad.»',
    url: 'https://www.madrid.es/subvenciones-emprendimiento-2026',
  }),
  opp({
    id: 'faro-008', kind: 'convocatoria',
    title: 'Convocatoria de proyectos de transición ecológica justa',
    funder: 'Fundación Biodiversidad', funderShort: 'F. Biodiversidad',
    org: 'all', destination: 'proyecto',
    amount: 200_000, coFunding: '85% de los costes elegibles',
    published: '2026-08-20', deadline: '2026-12-01',
    scope: 'España',
    sourceId: 'src-mail-all', detectedAt: '2026-08-30T09:08:00',
    score: 84, status: 'interesting',
    tags: ['Sostenibilidad', 'Transición justa', 'Empleo verde'],
    summary: 'Financiación de proyectos que combinen empleo verde, formación y desarrollo territorial en zonas en transición.',
    requirements: ['Consorcio con al menos 2 entidades', 'Duración mínima 24 meses', 'Indicadores de empleo verde generado'],
    matched: ['Importe ≥ 25.000 €', 'Temática: sostenibilidad', 'Plazo > 30 días', 'Ámbito: España'],
    unmatched: [],
    excerpt: '«Las actuaciones deberán contribuir de forma directa a la creación de empleo verde y a la capacitación de personas trabajadoras en sectores en transición.»',
    url: 'https://fundacion-biodiversidad.es/convocatoria-transicion-justa',
  }),
  opp({
    id: 'faro-009', kind: 'subvencion',
    title: 'Ajuts a projectes d\'economia social i solidària (Barcelona Activa)',
    funder: 'Barcelona Activa', funderShort: 'BCN Activa',
    org: 'ih-bcn', destination: 'proyecto',
    amount: 75_000, coFunding: '80% del projecte',
    published: '2026-08-19', deadline: '2026-09-25',
    scope: 'Barcelona',
    sourceId: 'src-mail-bcn', detectedAt: '2026-08-30T09:09:00',
    score: 77, status: 'interesting',
    tags: ['Economía social', 'Local'],
    summary: 'Ayudas a entidades que impulsen proyectos cooperativos y de economía solidaria en los barrios de Barcelona.',
    requirements: ['Sede o actividad en Barcelona', 'Proyecto de base comunitaria', 'Memoria de impacto en el barrio'],
    matched: ['Ámbito: Barcelona', 'Temática: economía social', 'Importe ≥ 25.000 €'],
    unmatched: ['Plazo ajustado (< 30 días)'],
    excerpt: '«Es valorarà l\'arrelament al territori i la col·laboració amb entitats del barri.»',
    url: 'https://www.barcelonactiva.cat/ajuts-ess-2026',
  }),
  opp({
    id: 'faro-010', kind: 'convocatoria',
    title: 'Convocatoria de innovación social urbana — Fundación Daniel y Nina Carasso',
    funder: 'Fundación Daniel y Nina Carasso', funderShort: 'Carasso',
    org: 'all', destination: 'proyecto',
    amount: 90_000, coFunding: 'Hasta 90.000 € en 3 años',
    published: '2026-08-18', deadline: '2026-10-20',
    scope: 'España y Francia',
    sourceId: 'src-mail-all', detectedAt: '2026-08-29T09:10:00',
    score: 80,
    tags: ['Alimentación sostenible', 'Arte ciudadano', 'Innovación social'],
    summary: 'Proyectos que conecten alimentación sostenible y participación ciudadana en entornos urbanos.',
    requirements: ['Entidad con 3 años de antigüedad', 'Enfoque participativo', 'Evaluación externa del impacto'],
    matched: ['Temática: innovación social', 'Importe ≥ 25.000 €', 'Plazo > 30 días'],
    unmatched: [],
    excerpt: '«Las propuestas deberán articular la dimensión alimentaria y la dimensión cultural en un mismo proceso participativo.»',
    url: 'https://www.fondationcarasso.org/es/convocatoria-innovacion-urbana',
  }),
  opp({
    id: 'faro-011', kind: 'subvencion',
    title: 'Ayudas para congresos y jornadas científico-empresariales',
    funder: 'IVACE+i · Generalitat Valenciana', funderShort: 'IVACE',
    org: 'all', destination: 'evento',
    amount: 18_000, coFunding: '60% del presupuesto del evento',
    published: '2026-08-17', deadline: '2026-09-08',
    scope: 'C. Valenciana',
    sourceId: 'src-eu', detectedAt: '2026-08-29T09:11:00',
    score: 48,
    tags: ['Eventos', 'Innovación'],
    summary: 'Apoyo a la organización de congresos empresariales de carácter innovador en la Comunitat Valenciana.',
    requirements: ['Evento celebrado en la Comunitat Valenciana', 'Al menos 100 participantes', 'Programa científico validado'],
    matched: ['Destino: eventos', 'Ámbito: C. Valenciana'],
    unmatched: ['Importe < 25.000 €', 'Plazo ajustado (< 30 días)'],
    excerpt: '«Quedan excluidos los gastos de restauración que superen el 15% del presupuesto total.»',
    url: 'https://www.ivace.es/ayudas-congresos-2026',
  }),
  opp({
    id: 'faro-012', kind: 'convocatoria',
    title: 'Programa Impulsa Mujeres Emprendedoras 2027',
    funder: 'Fundación Banco Sabadell', funderShort: 'F. Sabadell',
    org: 'all', destination: 'proyecto',
    amount: 50_000, coFunding: 'Ayuda directa + mentoría',
    published: '2026-08-16', deadline: '2026-11-05',
    scope: 'España',
    sourceId: 'src-mail-all', detectedAt: '2026-08-28T09:12:00',
    score: 76,
    tags: ['Emprendimiento', 'Igualdad', 'Mentoría'],
    summary: 'Programa de apoyo a proyectos liderados por mujeres, con dotación económica y acompañamiento experto.',
    requirements: ['Proyecto liderado por mujeres', 'Entidad operativa en España', 'Compromiso de participación en la mentoría'],
    matched: ['Temática: emprendimiento', 'Importe ≥ 25.000 €', 'Plazo > 30 días'],
    unmatched: [],
    excerpt: '«El programa selecciona 12 proyectos anuales que reciben una dotación de hasta 50.000 euros.»',
    url: 'https://www.fundacionbancosabadell.com/impulsa-2027',
  }),
  opp({
    id: 'faro-013', kind: 'subvencion',
    title: 'Subvenciones a entidades para la digitalización del tercer sector',
    funder: 'Ministerio de Derechos Sociales', funderShort: 'Min. D. Sociales',
    org: 'all', destination: 'proyecto',
    amount: 120_000, coFunding: '90% de los costes',
    published: '2026-08-14', deadline: '2026-09-05',
    scope: 'España',
    sourceId: 'src-mail-all', detectedAt: '2026-08-28T09:13:00',
    score: 58, status: 'discarded',
    discardReason: 'Requiere declaración de utilidad pública que Impact Hub no tiene.',
    tags: ['Digitalización', 'Tercer sector'],
    summary: 'Ayudas para la modernización tecnológica de entidades del tercer sector de acción social.',
    requirements: ['Declaración de utilidad pública', 'Ámbito estatal', 'Ejecución en 12 meses'],
    matched: ['Importe ≥ 25.000 €', 'Temática: digitalización'],
    unmatched: ['Requisito jurídico no cumplido', 'Plazo ajustado (< 30 días)'],
    excerpt: '«Podrán ser beneficiarias las entidades declaradas de utilidad pública inscritas en el registro estatal.»',
    url: 'https://www.mdsocialesa2030.gob.es/subvenciones-digitalizacion',
  }),
  opp({
    id: 'faro-014', kind: 'convocatoria',
    title: 'Convocatoria de eventos de comunidad — Impact Hub Global Fund',
    funder: 'Impact Hub Global', funderShort: 'IH Global',
    org: 'all', destination: 'evento',
    amount: 12_000, coFunding: '50% del coste del evento',
    published: '2026-08-12', deadline: '2026-10-08',
    scope: 'Red global',
    sourceId: 'src-mail-all', detectedAt: '2026-08-27T09:14:00',
    score: 69,
    tags: ['Eventos', 'Comunidad', 'Red'],
    summary: 'Microfinanciación para eventos de comunidad organizados por hubs de la red.',
    requirements: ['Ser hub activo de la red', 'Evento abierto a la comunidad local', 'Reporte de impacto en 30 días'],
    matched: ['Destino: eventos', 'Fuente prioritaria', 'Plazo > 30 días'],
    unmatched: ['Importe < 25.000 €'],
    excerpt: '«Grants of up to 12.000 EUR are available for community events with a clear local impact narrative.»',
    url: 'https://impacthub.net/global-fund-events',
  }),
  opp({
    id: 'faro-015', kind: 'subvencion',
    title: 'Ayudas Next Generation para hubs de innovación territorial',
    funder: 'Red.es · Next Generation EU', funderShort: 'Red.es',
    org: 'all', destination: 'proyecto',
    amount: 350_000, coFunding: '100% en régimen de concurrencia',
    published: '2026-08-10', deadline: '2026-12-18',
    scope: 'España',
    sourceId: 'src-eu', detectedAt: '2026-08-26T09:15:00',
    score: 86, status: 'interesting',
    tags: ['Innovación', 'Fondos europeos', 'Territorio'],
    summary: 'Financiación de hubs de innovación digital que presten servicios de acompañamiento a pymes del territorio.',
    requirements: ['Consorcio con universidad o centro tecnológico', 'Plan de servicios a 36 meses', 'Cofinanciación acreditada de estructura'],
    matched: ['Importe ≥ 25.000 €', 'Temática: innovación', 'Ámbito: España', 'Plazo > 30 días'],
    unmatched: ['Alta carga administrativa'],
    excerpt: '«La ayuda podrá alcanzar el 100% del coste subvencionable en el marco del Plan de Recuperación, Transformación y Resiliencia.»',
    url: 'https://www.red.es/ayudas-hubs-innovacion',
  }),
  opp({
    id: 'faro-016', kind: 'convocatoria',
    title: 'Prémio de Empreendedorismo Social 2027',
    funder: 'Fundação Calouste Gulbenkian', funderShort: 'Gulbenkian',
    org: 'all', destination: 'proyecto',
    amount: 100_000, coFunding: 'Prémio directo em duas tranches',
    published: '2026-08-08', deadline: '2026-10-25',
    scope: 'Portugal',
    sourceId: 'src-eu', detectedAt: '2026-08-26T09:16:00',
    score: 82,
    tags: ['Emprendimiento social', 'Portugal'],
    summary: 'Premio a iniciativas de emprendimiento social con impacto demostrable en Portugal.',
    requirements: ['Iniciativa con actividad en Portugal', 'Impacto medido con indicadores', 'Presentación ante jurado'],
    matched: ['Ámbito: Portugal', 'Temática: emprendimiento social', 'Importe ≥ 25.000 €', 'Plazo > 30 días'],
    unmatched: [],
    excerpt: '«O prémio destina-se a projetos com um modelo de sustentabilidade financeira demonstrado.»',
    url: 'https://gulbenkian.pt/premio-empreendedorismo-2027',
  }),
  opp({
    id: 'faro-017', kind: 'subvencion',
    title: 'Ayudas a la formación en competencias verdes para pymes',
    funder: 'Fundae', funderShort: 'Fundae',
    org: 'all', destination: 'proyecto',
    amount: 80_000, coFunding: '100% para entidades acreditadas',
    published: '2026-08-06', deadline: '2026-09-30',
    scope: 'España',
    sourceId: 'src-mail-all', detectedAt: '2026-08-25T09:17:00',
    score: 70,
    tags: ['Formación', 'Sostenibilidad'],
    summary: 'Financiación de itinerarios formativos en sostenibilidad dirigidos a plantillas de pymes.',
    requirements: ['Entidad de formación acreditada', 'Mínimo 200 horas lectivas', 'Plataforma de seguimiento del alumnado'],
    matched: ['Temática: formación', 'Importe ≥ 25.000 €', 'Ámbito: España'],
    unmatched: ['Requiere acreditación como centro de formación'],
    excerpt: '«Las acciones formativas deberán impartirse en modalidad presencial o de aula virtual con control de asistencia.»',
    url: 'https://www.fundae.es/ayudas-competencias-verdes',
  }),
  opp({
    id: 'faro-018', kind: 'convocatoria',
    title: 'Beques a projectes culturals de proximitat',
    funder: 'Fundació Catalunya Cultura', funderShort: 'Cat. Cultura',
    org: 'ih-bcn', destination: 'evento',
    amount: 9_000, coFunding: '50% del pressupost',
    published: '2026-08-04', deadline: '2026-09-04',
    scope: 'Cataluña',
    sourceId: 'src-mail-bcn', detectedAt: '2026-08-25T09:18:00',
    score: 41, status: 'discarded',
    discardReason: 'Importe por debajo del mínimo definido en los criterios.',
    tags: ['Cultura', 'Eventos'],
    summary: 'Pequeñas becas para actividades culturales de barrio.',
    requirements: ['Actividad en Cataluña', 'Presupuesto máximo 18.000 €'],
    matched: ['Ámbito: Cataluña', 'Destino: eventos'],
    unmatched: ['Importe < 25.000 €', 'Plazo ajustado (< 30 días)'],
    excerpt: '«Les beques tenen una dotació màxima de 9.000 euros per projecte.»',
    url: 'https://catalunyacultura.cat/beques-proximitat',
  }),
];

export const FARO_CRITERIA = {
  themes: ['Emprendimiento', 'Innovación', 'Economía social', 'Sostenibilidad', 'Formación', 'Empleo e inclusión', 'Cultura', 'Culturales y Creativas', 'Comunicación', 'Regenerativo', 'Mediación Artística', 'Mediación Cultural', 'Digitalización'],
  eventKeywords: ['Jornada', 'Encuentro', 'Feria', 'Evento', 'Congreso', 'Exposiciones', 'Visita', 'Tour', 'Foros', 'Premio', 'Hackathons', 'Celebraciones', 'Networking'],
  minAmount: 25_000,
  minDays: 30,
  scopes: ['España', 'Portugal', 'Unión Europea'],
  destinations: { evento: true, proyecto: true },
  exclude: ['obra civil', 'investigación clínica', 'agricultura'],
  minScore: 55,
};

export const FARO_RUN = {
  lastRunAt: '2026-09-01T09:00:00',
  nextRunAt: '2026-09-02T09:00:00',
  newToday: 4,
  sourcesOk: 6,
  sourcesWarning: 2,
  sourcesError: 1,
  mailsScanned: 37,
  pagesScanned: 214,
  steps: [
    { id: 'web',    label: 'Rastreando fuentes web',        detail: '7 fuentes · 214 páginas' },
    { id: 'mail',   label: 'Revisando buzones de newsletter', detail: '3 buzones · 37 correos' },
    { id: 'ai',     label: 'Clasificando con IA',            detail: 'Tipo, destino y fechas clave' },
    { id: 'filter', label: 'Aplicando criterios generales',  detail: 'Encaje y organización' },
  ],
};

export const FARO_ALERTS = {
  enabled: true,
  hour: '09:00',
  weekdaysOnly: true,
  include: { new: true, closingSoon: true, interesting: true, discarded: false },
  recipients: [
    { org: 'all',    email: 'direccion@impacthub.net' },
    { org: 'ih-bcn', email: 'equipo.bcn@impacthub.net' },
    { org: 'ih-mad', email: 'equipo.mad@impacthub.net' },
  ],
};

export const FARO = {
  ORGS: FARO_ORGS,
  SOURCES: FARO_SOURCES,
  OPPORTUNITIES: FARO_OPPORTUNITIES,
  CRITERIA: FARO_CRITERIA,
  RUN: FARO_RUN,
  ALERTS: FARO_ALERTS,
};
